/**
 * Configures logging
 *
 * Disables $log.debug in production
 *
 * @type {ngConfig}
 */
let tmrLogConfig = /*@ngInject*/ $logProvider =>
  $logProvider.debugEnabled(process.env.env != 'production')

export { tmrLogConfig as config }
